module.exports = __webpack_public_path__ + "static/media/terry.aac9f57b.png";